import { FunctionComponent, useContext } from 'react';
import { ConfigContext } from '../configuration/ConfigContext';
import PaperLayout from '../layout/PaperLayout';
import AlertModal from '../modal/AlertModal';
import { usePropertyAssociationContext } from '../propertyAssociation/PropertyAssociationContext';
import Icon from '../shared/Icon';
import { ToastContext } from '../toaster/ToastContext';
import { ToastMessageType } from '../toaster/models/ToastMessageType';
import Toggle from './components/Toggle';
import { disableUserChat, enableUserChat, useUserChatStatus } from './conversationService';

const ChatSettings: FunctionComponent = () => {
    const { apiBaseUrl } = useContext(ConfigContext);
    const { currentPropertyAssociationId } = usePropertyAssociationContext();
    const { addToast } = useContext(ToastContext);
    const { isEnabled, isLoading, error } = useUserChatStatus();

    const updateEnableUserChat = () => {
        if (isEnabled === undefined) {
            addToast('Ett oväntat fel inträffade', 'Inställningarna kunde inte sparas, var god försök igen.', ToastMessageType.Error);
            return;
        }

        if (isEnabled === true) {
            if (confirm('Du kommer nu att stänga av boendechattar för hela föreningen. Detta innebär att medlemmar inte längre kan chatta med varandra.')) {
                disableUserChat(apiBaseUrl, currentPropertyAssociationId);
                addToast('Chattinställningar sparade', 'Boendechattar är nu avstängda.');
            } else {
                addToast('Ändring avbruten', '', ToastMessageType.Error);
            }
        } else {
            enableUserChat(apiBaseUrl, currentPropertyAssociationId);
            addToast('Chattinställningar sparade', 'Boendechattar är nu påslagna.');
        }
    };

    if (isLoading || isEnabled === undefined) {
        return (
            <PaperLayout heading="Chattinställningar" noBottomMargin>
                Loading...
            </PaperLayout>
        );
    }

    if (error) {
        return <AlertModal heading="Ett fel uppstod" text="Kunde inte hämta status" onClose={() => window.location.reload()} visible={true} />;
    }

    return (
        <PaperLayout heading="Chattinställningar" noBottomMargin>
            {!isEnabled ? (
                <div className="alert alert-warning" role="alert">
                    <Icon type="alert" width={20} height={20} color="#664d03" /> Boendechattar är avstängda för hela föreningen. Medlemmar kan inte chatta med varandra.
                </div>
            ) : (
                <div className="alert alert-info" role="alert">
                    <Icon type="check" width={20} height={20} color="#055160" /> Boendechattar är aktiverade för hela föreningen. Medlemmar kan chatta med varandra.
                </div>
            )}

            <div>
                <Toggle value={isEnabled} onChange={updateEnableUserChat} label="Tillåt boendechattar inom föreningen" name="enableChat" />
            </div>
        </PaperLayout>
    );
};

export default ChatSettings;
